<template>
  <div class="mobile-menu d-md-none d-block mobile-cart">
    <ul>
      <li>
        <router-link to="/" class="menu-box" exact-active-class="active">
          <i class="ri-map-pin-line"></i> <span>{{ $t("map") }}</span></router-link
        >
      </li>
      <li>
        <router-link to="/order_list" class="menu-box" exact-active-class="active">
          <i class="ri-list-unordered"></i> <span>{{ $t("orders") }}</span></router-link
        >
      </li>

      <li>
        <router-link to="/profile" class="menu-box" exact-active-class="active">
          <i class="ri-user-line"></i><span>{{ $t("profile") }}</span></router-link
        >
      </li>
    </ul>
  </div>
</template>

<script setup></script>
